import { IQuoteSummary } from "../interfaces/IQuoteSummery";
import { thanos26GetJson } from "./thanos26Client";

//#######################################################
//TIMESAFE OFFER
//#######################################################

export async function getTimesafeOfferByOffer(
    from: string | null,
    to: string | null,
    quote: IQuoteSummary
): Promise<any> {
    let parameter = {};
    if (from !== null && to !== null) {
        parameter = { dtfrom: from, dtto: to, id: String(quote.id), version: String(quote.version) };
    } else {
        parameter = { id: String(quote.id), version: String(quote.version) };
    }
    return thanos26GetJson("manager/TimeSafeOffer", parameter);
}

export default { getTimesafeOfferByOffer };
